export enum StateControllerEvents {
    StateChange = 'stateChange'
}
